import { getLocalStorageMenuItem } from "./storage";
import i18n from "i18next";

// Dynamic language loaders — each produces a separate webpack chunk.
// Only the active language is downloaded at runtime.
const languageLoaders = {
  ar: () => import("../languages/Arabic.json"),
  fr: () => import("../languages/French.json"),
  "zh-Hans": () => import("../languages/Chinese.json"),
  ca: () => import("../languages/Catalan.json"),
  hr: () => import("../languages/Croatian.json"),
  cs: () => import("../languages/Czech.json"),
  da: () => import("../languages/Danish.json"),
  nl: () => import("../languages/Dutch.json"),
  et: () => import("../languages/Estonian.json"),
  de: () => import("../languages/German.json"),
  hu: () => import("../languages/Hungarian.json"),
  it: () => import("../languages/Italian.json"),
  mk: () => import("../languages/Macedonian.json"),
  nb: () => import("../languages/Norwegian.json"),
  fa: () => import("../languages/Persian.json"),
  pt: () => import("../languages/Portuguese-br.json"),
  "pt-pt": () => import("../languages/Portuguese-pt.json"),
  ro: () => import("../languages/Romanian.json"),
  ru: () => import("../languages/Russian.json"),
  ja: () => import("../languages/Japanese.json"),
  es: () => import("../languages/Spanish.json"),
  tr: () => import("../languages/Turkish.json"),
  uk: () => import("../languages/Ukranian.json"),
  ko: () => import("../languages/Korean.json"),
  sv: () => import("../languages/Swedish.json"),
};

/**
 * Load a language bundle dynamically and switch i18n to it.
 * Safe to call multiple times — already-loaded bundles are skipped.
 */
export const loadAndChangeLanguage = async (lang) => {
  if (!lang) { i18n.changeLanguage("en"); return; }
  if (lang !== "en" && !i18n.hasResourceBundle(lang, "translation")) {
    const loader = languageLoaders[lang];
    if (loader) {
      try {
        const mod = await loader();
        i18n.addResourceBundle(lang, "translation", mod.default || mod, true, true);
      } catch (e) {
        // Fall back to English if load fails
        i18n.changeLanguage("en");
        return;
      }
    }
  }
  i18n.changeLanguage(lang);
};

export const GetTextFontByLang = ($type) => {
  const language = getLocalStorageMenuItem("lang");
  const isRTL = language === "ar" || language === "fa";

  if ($type === "h") return isRTL ? "lang_ar_head" : "lang_head";
  if ($type === "s") return isRTL ? "lang_ar_sub" : "lang_sub";
  return "";
};

export const SetTextAlignByLang = () => {
  const language = getLocalStorageMenuItem("lang");
  return (language === "ar" || language === "fa") ? "rtl text-end" : "ltr text-start";
};

export const setLang = () => {
  const lang = getLocalStorageMenuItem("lang");
  return (lang === "ar" || lang === "fa") ? "arabic-font" : "latino-font";
};

export const AllLanguagesNames = (lang) => {
  const languages = [
    { ar: "Arabic" }, { en: "English" }, { fr: "French" },
    { "zh-Hans": "Chinese" }, { ca: "Catalan" }, { hr: "Croatian" },
    { cs: "Czech" }, { da: "Danish" }, { nl: "Dutch" },
    { et: "Estonian" }, { de: "German" }, { hu: "Hungarian" },
    { it: "Italian" }, { mk: "Macedonian" }, { nb: "Norwegian" },
    { fa: "Persian" }, { pt: "Portuguese-br" }, { "pt-pt": "Portuguese-pt" },
    { ro: "Romanian" }, { ru: "Russian" }, { ja: "Japanese" },
    { ko: "Korean" }, { es: "Spanish" }, { tr: "Turkish" },
    { uk: "Ukranian" }, { sv: "Swedish" },
  ];

  const selected = languages.filter((language) => language[lang]);
  if (selected[0]) return selected[0][lang];
};

export const AllLanguagesCode = [
  "ja", "ko", "ar", "en", "az", "ca", "zh-Hans", "hr", "cs", "da",
  "nl", "et", "fa", "fr", "de", "he", "hu", "it", "mk", "nb",
  "pt", "pt-pt", "ro", "ru", "es", "sv", "tr", "uk",
];

export const languagesOptions = [
  { code: "ar", label: "Arabic" }, { code: "en", label: "English" },
  { code: "fr", label: "French" }, { code: "zh-Hans", label: "Chinese" },
  { code: "ca", label: "Catalan" }, { code: "hr", label: "Croatian" },
  { code: "cs", label: "Czech" }, { code: "da", label: "Danish" },
  { code: "nl", label: "Dutch" }, { code: "et", label: "Estonian" },
  { code: "de", label: "German" }, { code: "hu", label: "Hungarian" },
  { code: "it", label: "Italian" }, { code: "mk", label: "Macedonian" },
  { code: "nb", label: "Norwegian" }, { code: "fa", label: "Persian" },
  { code: "pt", label: "Portuguese-br" }, { code: "pt-pt", label: "Portuguese-pt" },
  { code: "ro", label: "Romanian" }, { code: "ru", label: "Russian" },
  { code: "ja", label: "Japanese" }, { code: "ko", label: "Korean" },
  { code: "es", label: "Spanish" }, { code: "tr", label: "Turkish" },
  { code: "uk", label: "Ukranian" }, { code: "sv", label: "Swedish" },
];
